export const POWER_UP_COLLECTED_EVENT = 'powerup-collected'

export type PowerUpCollectedDetail = {
    powerUpIndex: number
}

export function dispatchPowerUpCollected(powerUpIndex: number) {
    window.dispatchEvent(
        new CustomEvent<PowerUpCollectedDetail>(POWER_UP_COLLECTED_EVENT, {
            detail: { powerUpIndex },
        }),
    )
}
